module.exports = __webpack_public_path__ + "img/avatar.baed6a90.png";